import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Card, CardTitle, Skeleton } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'
import { earningsHeadlineLevels } from '@/metrics/pages/PerformanceInsightsPage/GlobalTab/EarningsSection/constants'

import { earningsHeadlineCopies } from '../constants'
import * as Styles from './styles'

const YourEarningsCardSkeleton = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Card>
      <CardTitle marginBottom={theme.spacing.sp16}>{t('Tus ganancias')}</CardTitle>
      <CardDescription>{t(earningsHeadlineCopies[earningsHeadlineLevels.operating].subtitle)}</CardDescription>
      <Styles.Content>
        <Styles.Block>
          <Skeleton variant="text" width={120} height={48} />
          <Skeleton variant="text" width={260} height={16} />
        </Styles.Block>
        <Styles.Group>
          <Styles.Block>
            <Skeleton variant="text" width={110} height={12} />
            <Skeleton variant="text" width={70} height={28} />
          </Styles.Block>
          <Styles.Block>
            <Skeleton variant="text" width={110} height={12} />
            <Skeleton variant="text" width={70} height={28} />
          </Styles.Block>
        </Styles.Group>
      </Styles.Content>
    </Card>
  )
}

export default YourEarningsCardSkeleton
